const SORT_ORDERS = ['asc', 'desc'] as const
export type ValidSortOrder = (typeof SORT_ORDERS)[number]
export type SortType = 'string' | 'number' | 'date' | 'boolean'

export function isValidSortOrder(order: string): order is ValidSortOrder {
  return SORT_ORDERS.includes(order as ValidSortOrder)
}
